import styled from '@emotion/styled';
import { IStyledRadioButtonProps } from './Types';

export const Radio = styled.input`
  position: absolute;
  left: -20000px;
`;

export const CheckMark = styled.div<IStyledRadioButtonProps>`
  height: 1.125rem;
  width: 1.125rem;
  min-width: 1.125rem;
  border: 1px solid
    ${({ $checked, radioColor }) => ($checked ? radioColor : '#AEADAD')};
  border-radius: 50%;
  position: relative;
  &::after {
    position: absolute;
    content: ' ';
    transition: right 0.2s, bottom 0.2s, top 0.2s, left 0.2s;
    background: ${({ $checked, radioColor }) => $checked && radioColor};
    top: ${({ $checked }) => ($checked ? -4 : 50)}%;
    left: ${({ $checked }) => ($checked ? -4 : 50)}%;
    right: ${({ $checked }) => ($checked ? -4 : 50)}%;
    bottom: ${({ $checked }) => ($checked ? -4 : 50)}%;
    border-radius: 50%;
  }
`;

export const Label = styled.label<IStyledRadioButtonProps>`
  display: flex;
  gap: 0.75rem;
  align-items: center;
  color: #000;
  font-weight: ${({ $checked }) => ($checked ? 700 : 400)};
  cursor: pointer;
  width: 100%;
  height: 100%;
  flex: 1.125rem 1;
  &:hover {
    font-weight: 700;
    ${CheckMark} {
      border-color: ${({ radioColor }) => radioColor};
    }
  }
  overflow: hidden;
  @media screen and (min-width: 640px) {
    gap: 1.125rem;
  }
`;
